import React, { Component } from 'react';
import styled from 'styled-components';
import Swiper from 'swiper/dist/js/swiper.js'
import 'swiper/dist/css/swiper.min.css';

import WP from 'WP';
import pointerLeft from 'images/pointerLeft.svg';

class Slider extends Component {
    
    componentDidMount() {

        new Swiper('.swiper-container', {
            effect: this.props.effect ? this.props.effect : false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            initialSlide: this.props.initialSlide ? this.props.initialSlide: 0,
            autoplay: this.props.autoPlay ? { delay: this.props.autoplayInterval || 3000 } : false,
            disableOnInteraction:  this.props.autoPlay,
            loadOnTransitionStart: true,
            loadPrevNext: true,
            speed: 1500,
            loop: true,
            slideToClickedSlide: true,
            preventClicksPropagation: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            on: {
                slideChangeTransitionStart: function() {
                    const slides = this.el.childNodes[0].childNodes;
                    slides.forEach((e) => {
                        if(e.classList.contains("swiper-slide-active") || e.classList.contains("swiper-slide-duplicate-active")){
                            e.lastChild.lastChild.style.animationName = "animate";
                        }
                    });
                },
                slideChangeTransitionEnd: function() {
                    const slides = this.el.childNodes[0].childNodes;
                    slides.forEach((e) => {
                        if(!e.classList.contains("swiper-slide-active")
                            && !e.classList.contains("swiper-slide-duplicate-active")
                            && !e.classList.contains('swiper-slide-prev')
                            && !e.classList.contains('swiper-slide-next')
                        ){
                            e.lastChild.lastChild.style.animationName = "";
                        }
                    });
                }
            }
        });
    }

    render() {
        const { slides, bleedOnMobile, withArrows, withBullets, kenBurns } = this.props;
        return(
            <SliderWrapper className="swiper-container" kenBurns={kenBurns} bleedOnMobile={bleedOnMobile} withArrows={withArrows} withBullets={withBullets} >
                <div className="swiper-wrapper">
                    {slides.map((slide, i) => {
                        if(slide.props.image || slide.props.children)
                        return(
                            <div key={i} className="swiper-slide" >
                                {slide}
                            </div>
                        );
                    })}
                </div>
                <div className="swiper-pagination"></div>
                <div className="swiper-button-next">
                    <img src={WP.assets+pointerLeft} alt="pointer left"/>
                </div>
                <div className="swiper-button-prev">
                    <img src={WP.assets+pointerLeft} alt="pointer left"/>    
                </div>
            </SliderWrapper>
        );
    }
}

export default Slider;

const SliderWrapper = styled.div`

    ${props => props.bleedOnMobile ? `
        @media (max-width:480px) {
            width: calc( 100% + 50px);
            margin-left:-25px!important;
            margin-right:-25px!important;
        }
    ` : ``}
    .swiper-pagination {
        bottom:30px!important;
        @media (max-width:480px) {
            bottom:15px!important;
        }
        ${props => !props.withBullets ? `display:none;` : ``}
    }
    .swiper-pagination-bullet {
        background: transparent;
        opacity:1;
        position:relative;
        border: 1px solid #fff;
        width:10px;
        height:10px;
        &.swiper-pagination-bullet-active {
            background: #fff;
        }
    }
    .swiper-slide {  
        position: relative;
        
        ${props => props.kenBurns ? `
        @keyframes animate {
            from {
                transform: scale(1);                
            }
            to {               
               transform: scale(1.04);
            }
        }
        .lazy-image-bgd{            
            transform: scale(1.04);
            animation-duration: 10.0s;            
            animation-fill-mode: forwards;    
            animation-timing-function: linear;     
            animation-iteration-count: 1;    
        }
    `   
        : ''}
    
        a{
            display: block;
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 2;
        }
        > div {
            @media (max-width:480px) {
                padding:0;
                height:190px;
            }
        }
    }
    .swiper-button-prev {
        display: ${props => !props.withArrows ? `none` : `flex`};
        width: 280px;
        height: 100%;
        margin-top: 0;
        background: none;
        left: 0;
        top: 0;
        align-items: center;
        padding-left:35px;
        outline: none;
        transition: all .5s ease-in-out;
        transform: translateX(-50%);
        @media (max-width:768px) {
            width: 100px;
            transform: translateX(-100%);
        }
        @media (max-width:480px) {
            width: 80px;
            transform: translateX(0);
            padding-left:15px;
        }
    }
    .swiper-button-next {
        display: ${props => !props.withArrows ? `none` : `flex`};
        width:280px;
        height: 100%;
        margin-top: 0;
        background: none;
        right: 0;
        top: 0;
        align-items: center;
        padding-right:35px;
        justify-content: flex-end;
        outline: none;
        transition: all .5s ease-in-out;
        transform: translateX(50%);
        @media (max-width:768px) {
            width: 100px;
            transform: translateX(100%);
        }
        @media (max-width:480px) {
            width: 80px;
            transform: translateX(0);
            padding-right:15px;
        }
        img {
            transform: rotate(180deg);
        }
    }
    &:hover {
        .swiper-button-prev {
            transform: translateX(0%);
        }
        .swiper-button-next {
            transform: translateX(0%);
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/Slider.js